const STORAGE_KEY = "mediconsult_preferred_language";

export const normalizePreferredLanguage = (value) => {
  const locale = String(value || "de").trim().toLowerCase();
  return locale === "en" ? "en" : "de";
};

export const getStoredPreferredLanguage = () => {
  if (typeof window === "undefined") return "de";
  try {
    return normalizePreferredLanguage(window.localStorage.getItem(STORAGE_KEY));
  } catch {
    return "de";
  }
};

export const setStoredPreferredLanguage = (value) => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, normalizePreferredLanguage(value));
  } catch {
    /* ignore */
  }
};

export const resolvePreferredLanguage = (user) =>
  normalizePreferredLanguage(user?.preferredLanguage || getStoredPreferredLanguage());
